import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { ServiceManifestDataForm, ServiceManifestFilters } from '../../models/ServiceManifest';
import { Service } from '../../models/Service';
import { fetchDefaultHeaders } from '../shared/vars';

const useServiceManifestService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetServiceManifests, setFetchingGetServiceManifests] = useState(false);
    const [fetchingShowServiceManifest, setFetchingShowServiceManifest] = useState(false);
    const [fetchingCreateServiceManifest, setFetchingCreateServiceManifest] = useState(false);
    const [fetchingStoreServiceManifest, setFetchingStoreServiceManifest] = useState(false);
    const [fetchingEditServiceManifest, setFetchingEditServiceManifest] = useState(false);
    const [fetchingUpdateServiceManifest, setFetchingUpdateServiceManifest] = useState(false);
    const [fetchingDeleteServiceManifest, setFetchingDeleteServiceManifest] = useState(false);
    const [fetchingActiveServiceManifest, setFetchingActiveServiceManifest] = useState(false);
    const [fetchingChangeStatusServiceManifest, setFetchingChangeStatusServiceManifest] =
        useState(false);
    const [fetchingHasFinishedStatuses, setFetchingHasFinishedStatuses] = useState(false);
    const [fetchingStoreServiceManifestOnDispatchProgram, setFetchingStoreServiceManifestOnDispatchProgram] = useState(false);
    const [fetchingGoServiceManifest, setGoServiceManifestes] = useState(false);
    const [fetchingUpdateServiceManifestInvoicing, setFetchingUpdateServiceManifestInvoicing] = useState(false);


    const getServiceManifests = (
        serviceManifestFilters: ServiceManifestFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(serviceManifestFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.SERVICE_MANIFEST.GET_SERVICE_MANIFESTS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetServiceManifests
        });
    };

    const showServiceManifest = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.SHOW_SERVICE_MANIFEST.replace(':id', id.toString()),
            setFetching: setFetchingShowServiceManifest
        });
    };

    const createServiceManifest = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.CREATE_SERVICE_MANIFEST,
            setFetching: setFetchingCreateServiceManifest
        });
    };

    const storeServiceManifest = (
        serviceManifest: ServiceManifestDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.STORE_SERVICE_MANIFEST,
            body: serviceManifest,
            setFetching: setFetchingStoreServiceManifest
        });
    };

    const editServiceManifest = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.EDIT_SERVICE_MANIFEST.replace(':id', id.toString()),
            setFetching: setFetchingEditServiceManifest
        });
    };

    const updateServiceManifest = (
        id: number,
        serviceManifest: ServiceManifestDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.UPDATE_SERVICE_MANIFEST.replace(':id', id.toString()),
            body: serviceManifest,
            setFetching: setFetchingUpdateServiceManifest
        });
    };

    const updateServiceManifestInvoicing = (id: number, serviceManifest: ServiceManifestDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.UPDATE_SERVICE_MANIFEST_INVOICING.replace(':id', id.toString()),
            body: serviceManifest,
            setFetching: setFetchingUpdateServiceManifestInvoicing
        });
    };
    
    const deleteServiceManifest = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.DELETE_SERVICE_MANIFEST.replace(':id', id.toString()),
            setFetching: setFetchingDeleteServiceManifest
        });
    };

    const hasAllFinishedStatuses = (id: number, status: string, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.HAS_ALL_FINISHED_STATUSES.replace(
                ':id',
                id.toString()
            ).replace(':service_manifest_status', status),
            setFetching: setFetchingHasFinishedStatuses
        });
    };



    const changeStatusServiceManifest = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.CHANGE_STATUS_SERVICE_MANIFEST.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusServiceManifest
        });
    };

    const storeServiceManifestOnDispatchProgram = (
        serviceManifest: ServiceManifestDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.STORE_SERVICE_MANIFEST_ON_DISPATCH_PROGRAM,
            body: serviceManifest,
            setFetching: setFetchingStoreServiceManifestOnDispatchProgram
        });
    };

    const goServiceManifest = (interlocutor_id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SERVICE_MANIFEST.GO_SERVICE_MANIFEST.replace(
                ':interlocutor_id', interlocutor_id.toString()
            ),
            setFetching: setGoServiceManifestes
        });
    };

    
    const getExcelAllServiceManifest = (serviceManifestFilters: ServiceManifestFilters, events: ServiceEvents = {}) => {
        // if (showLoading) showLoading('download', 'descargando archivo...');

        const queryString = Object.entries(serviceManifestFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = new URL(`${EndPoints.SERVICE_MANIFEST.GET_EXCELL_SERVICE_MANIFEST}?${queryString}`);
        

        fetch(url.href, { headers: { ...fetchDefaultHeaders } })
            .then((response) => {
                response
                    .blob()
                    .then((blob) => {
                        const a = document.createElement('a');
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = 'hojas_de_entrada.xlsx';
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            })
            .catch((error) => {
                console.log(error)
            });
    };



    return {
        fetchingGetServiceManifests,
        fetchingShowServiceManifest,
        fetchingCreateServiceManifest,
        fetchingStoreServiceManifest,
        fetchingEditServiceManifest,
        fetchingUpdateServiceManifest,
        fetchingDeleteServiceManifest,
        fetchingActiveServiceManifest,
        fetchingHasFinishedStatuses,
        fetchingChangeStatusServiceManifest,
        fetchingStoreServiceManifestOnDispatchProgram,
        fetchingGoServiceManifest,
        fetchingUpdateServiceManifestInvoicing,
        getServiceManifests,
        showServiceManifest,
        createServiceManifest,
        storeServiceManifest,
        editServiceManifest,
        updateServiceManifest,
        updateServiceManifestInvoicing,
        deleteServiceManifest,
        hasAllFinishedStatuses,
        changeStatusServiceManifest,
        storeServiceManifestOnDispatchProgram,
        goServiceManifest,
        getExcelAllServiceManifest
    };
};

export default useServiceManifestService;
